import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { updateFolderSettings } from '../../services/api'

interface AggregationToggleProps {
  projectId: string
  folderId: string
  value: boolean
  onChange: (value: boolean) => void
}

export default function AggregationToggle({ projectId, folderId, value, onChange }: AggregationToggleProps) {
  const [checked, setChecked] = useState(value)

  const mutation = useMutation({
    mutationFn: (newValue: boolean) => updateFolderSettings(projectId, folderId, { aggregate_children: newValue }),
    onSuccess: (_, newValue) => {
      setChecked(newValue)
      onChange(newValue)
    },
  })

  const handleToggle = () => {
    const newValue = !checked
    mutation.mutate(newValue)
  }

  return (
    <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer select-none">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={handleToggle}
        disabled={mutation.isPending}
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
          checked ? 'bg-iflow-500' : 'bg-gray-300'
        } ${mutation.isPending ? 'opacity-50' : ''}`}
      >
        <span
          className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${
            checked ? 'translate-x-4' : 'translate-x-0.5'
          }`}
        />
      </button>
      Include child folder lists
      {mutation.isPending && <Loader2 className="w-3.5 h-3.5 animate-spin text-gray-500" />}
    </label>
  )
}
